<template>
  <div class="im-store" style="-webkit-app-region: drag">
    <div style="height: 44px; background: #eee;padding: 10px;border-right: 1px solid #dcdee2;display: flex;justify-content: space-between;">
      <div>我的店铺</div>
      <div>      
        <Icon @click="hang" style="cursor: pointer;" type="md-settings" />
      </div>
    </div>
    <div class="lazada-store-wrap" ref="personWrap">
      <Scroll :height="scrollHeight">
      <List :split="false" class="store-list">
          <ListItem @click.native="setCurrentStore(store)" v-for="(store, index) in storeList" :key="index" :class="{active: activeStore == store.seller_id, 'expire-store': store.im_expiresin_text == '已过期'}" class="store-item">
            <div style="padding: 0px 10px;position: relative;">
              
              <Badge :count="unread_count(store.seller_id)">
                  <Avatar :src="(store.im_expiresin_text != '已过期' ? store.logo_url : logo_url_grey)" shape="square" icon="ios-person" />
                  <div v-show="store.hang == 1" @click="nohang(store)" style="position: absolute;top: 16px;right: 0px;">
                    <Icon color="#ff0000" type="ios-pause" />
                  </div>
              </Badge>
              <Badge v-if="transfer_count(store.seller_id)" text="转" type="primary">
                  <a href="#" class="demo-badge"></a>
              </Badge>
              <span class="store-name">{{store.name}}</span>
              
            </div>
            
            <div style="margin-left: 20px;position: absolute;right: 0px;padding: 5px;">
              <Dropdown trigger="click" style="padding: 10px;">
                  <a href="javascript:void(0)">
                      <Icon type="ios-arrow-down"></Icon>
                  </a>
                  <DropdownMenu slot="list">
                      <DropdownItem @click.native="hang(store)">挂起</DropdownItem>
                  </DropdownMenu>
              </Dropdown>
            </div>
          </ListItem>
      </List>
      </Scroll>
    </div>
    
  </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import conf from "../../conf";

export default {
  data() {
    return {
      // 默认选中的值
      scrollHeight: 500,
      icon: "ios-square-outline",
      isStoreDown: false,
      logo_url_grey: require('@/static/img/logo_url_grey.png')
    };
  },
  created() {
    
  },
  computed: {
    storeList: {
      get: function() {
        return this.$store.state.lazada.storeList;
      }
    },
    sessionData: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        if (this.$store.state.lazada.sessionData[seller_id]) {        
          return this.$store.state.lazada.sessionData[seller_id];
        }
        return [];
      },
    },
    activeStore: {
      get: function () {
        return this.$store.state.lazada.currentStore.seller_id;
      }
    },
    unread_count() {
      return function (seller_id) {
        return this.$store.state.lazada.storeData[seller_id].unread_count; 
      }
    },
    transfer_count() {
      return function (seller_id) {
        return this.$store.state.lazada.storeData[seller_id].transfer_count; 
      }
    }
  },
  methods: {
    storeDown() {
      this.isStoreDown = !this.isStoreDown;
    },
    setCurrentStore(store) {
      this.$store.commit("lazada/setCurrentStore", store);
      this.$emit('updatesession');
    },
    selectstore(store, callback) {
      let self = this;
      let param = new FormData();
      param.set("store_id", store.id);
      param.set("connector", 'lazada');

      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        data.store_id = store.id;
        data.seller_id = store.seller_id;
        let session_list = [];
        for (let i=0; i<data.session_list.length; i++) {
          if (data.session_list[i].last_message_time) {
            session_list.push(data.session_list[i]);
          }
        }
        data.session_list = session_list;
        self.$store.commit("lazada/setSessionData", data);
        // self.$emit('updatesession');
        callback && callback();
      })
      .then(() => {
        self.moreSession(2, store.seller_id);
      })
    },
    moreSession(next, seller_id) {
      if (!next) return false;
      let self = this;
      let sessionData = this.$store.state.lazada.sessionData[seller_id];
      let param = new FormData();
      param.set("store_id", sessionData.store_id);
      param.set("connector", 'lazada');
      param.set("next_start_time", sessionData.next_start_time);
      param.set("last_session_id", sessionData.last_session_id);

      RequestUtils.request(conf.getSessionList(), param)
      .then(data => {
        let session_list = [];
        for (let i=0; i<data.session_list.length; i++) {
          if (data.session_list[i].last_message_time) {
            session_list.push(data.session_list[i]);
          }
        }
        data.session_list = session_list;
        data.seller_id = sessionData.seller_id;
        self.$store.commit("lazada/pushSessionList", data);
        next--;
        self.moreSession(next, seller_id);
      })
    },
    // 获取所有店铺id
    getStoreIds () {
      let store_ids = new Array();
      for (let i=0; i<this.storeList.length; i++) {
        store_ids.push(this.storeList[i].id);
      }
      return store_ids;
    },
    // 挂起店铺
    hang (store) {
      let store_ids = null;
      if (store.id) {
        store_ids = [store.id];
      } else {
        store_ids = this.getStoreIds();
      }
      let param = new FormData();
      param.set("store_ids", store_ids.join(',') );
      param.set("platform", 'lazada' );

      RequestUtils.request(conf.hangStore(), param, {loading: true})
      .then(() => {                  
        for (let i=0; i<store_ids.length; i++) {
          this.$store.commit("lazada/setStoreAttr", {
            'id': store_ids[i],
            'attr': 'hang',
            'value': 1
          });
        }
        this.$Message.success('店铺已被挂起');
      })
    },
    // 取消挂起
    nohang (store) {
      let param = new FormData();
      param.set("store_id", store.id );
      param.set("platform", 'lazada' );
      param.set("operate", 'nohang' );

      RequestUtils.request(conf.hangStore(), param)
      .then(() => {                  
        this.$store.commit("lazada/setStoreAttr", {
          'id': store.id,
          'attr': 'hang',
          'value': 0
        });
      })
    },

  },
  mounted: function() {
    this.scrollHeight = document.querySelector('body').offsetHeight - 64 - 36 - 46 - 44;
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

$top-height: 4rem;
$color-online: #d1ffe9;

.lazada-store-wrap {
  position: relative;

  .store-list {
    
    .store-name {
      padding: 0px 1rem;

    }
    .store-item{
      cursor: pointer;
    }
    .store-item.active {
      background-color: rgba(0,29,233,.06);
      color: #07f;
    }
    .store-item.expire-store {
      opacity: .5
    }
    .expire-store .ivu-badge-count {
      background: #999;
    }

    .store-down {
      width: 50px;
      height: 52px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0px;
      right: 50px;
    }
  }
  .store-list.down {
    height: auto;
    z-index: 999;
    box-shadow: 1px 8px 18px rgba(0, 0, 0, 0.1);
  }
}
.store {
  height: 5.2rem;
  position: relative;

  a {
    display: block;
    width: 100%;
    height: 100%;
    color: $color-default;
    position: relative;

    i {
      display: inline-block;
      width: 1.8rem;
      height: 1.6rem;
      background-color: #ff0000;
      border-radius: 50%;
      color: $color-write;
      text-align: center;
      font-style: normal;
      position: absolute;
      left: 1rem;
      top: 0;
      z-index: 99999999999;
    }

    p {
      width: 12rem;
    }
  }


}
</style>
